import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginRegister.css";
import instance from "../../instance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Login({ setAuth }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [twoFactorCode, setTwoFactorCode] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [showTwoFactorInput, setShowTwoFactorInput] = useState(false);
  const [userId, setUserId] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // استرجاع البيانات المخزنة عند تحميل الصفحة لأول مرة
    const savedUsername = localStorage.getItem("savedUsername");
    const savedPassword = localStorage.getItem("savedPassword");
    const rememberMeChecked = localStorage.getItem("rememberMe") === "true";

    if (rememberMeChecked) {
      setUsername(savedUsername || "");
      setPassword(savedPassword || "");
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("Attempting login with:", { username, password, rememberMe });
      const response = await instance.post(`users/login`, {
        username,
        password,
        rememberMe,
      });

      console.log("Login response:", response.data);

      if (response.data.requiresTwoFactor) {
        // Clear any previous session token so in-flight requests with the old
        // token cannot 401-wipe the new session after verify2fa.
        localStorage.removeItem("token");
        setShowTwoFactorInput(true);
        setUserId(response.data.userId);
        toast.info("Please enter your 2FA code");
        return;
      }

      completeLogin(response.data);
    } catch (error) {
      console.error(
        "Login failed:",
        error.response ? error.response.data : error
      );
      toast.error(error.response?.data?.message || "Login failed");
    }
  };

  const handleTwoFactorSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("Attempting 2FA verification for user:", userId);
      const response = await instance.post(`users/login/verify2fa`, {
        userId,
        code: twoFactorCode,
      });

      console.log("2FA verification response:", response.data);

      if (response.data.success) {
        // استخدام جميع البيانات المستلمة من الخادم
        toast.success("2FA verification successful. Logging in...");
        completeLogin({
          userId: response.data.userId,
          token: response.data.token,
          role: response.data.role,
          username: response.data.username, // تأكد أن الخادم يعيد username
          lastLoginTime: response.data.lastLoginTime, // تأكد أن الخادم يعيد lastLoginTime
        });
      } else {
        toast.error("Invalid 2FA code");
      }
    } catch (error) {
      console.error(
        "2FA verification failed:",
        error.response ? error.response.data : error
      );
      toast.error(error.response?.data?.message || "2FA verification failed");
    }
  };

  const completeLogin = (data) => {
    console.log("Completing login with data:", data);
    const { userId, token, role, username: userName, lastLoginTime } = data;

    // حفظ البيانات في LocalStorage
    localStorage.setItem("userId", userId);
    localStorage.setItem("token", token);
    localStorage.setItem("role", role);
    localStorage.setItem("username", userName);
    localStorage.setItem("lastLoginTime", lastLoginTime);

    if (token && typeof token === "string" && token.split(".").length === 3) {
      localStorage.setItem("userId", userId);
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("username", userName);
      localStorage.setItem("lastLoginTime", lastLoginTime);
      setAuth(token);

      if (rememberMe) {
        localStorage.setItem("rememberMe", "true");
        localStorage.setItem("savedUsername", username);
        localStorage.setItem("savedPassword", password);
      } else {
        localStorage.removeItem("rememberMe");
        localStorage.removeItem("savedUsername");
        localStorage.removeItem("savedPassword");
      }

      navigate("/");
    } else {
      console.error("Invalid or missing token:", token);
      toast.error("Authentication failed. Please try logging in again.");

      navigate("/login");
    }
  };

  return (
    <div>
      <header>
        <h2>Login</h2>
      </header>
      <div className="container">
        <div className="login-register-box">
          <main>
            <form
              onSubmit={
                showTwoFactorInput ? handleTwoFactorSubmit : handleSubmit
              }
            >
              <div className="input-group">
                <label htmlFor="username">Username:</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              <div className="input-group">
                <label htmlFor="password">Password:</label>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="show show-password-toggle"
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
              {showTwoFactorInput && (
                <div className="input-group">
                  <label htmlFor="twoFactorCode">Two Factor Code:</label>
                  <input
                    type="text"
                    id="twoFactorCode"
                    value={twoFactorCode}
                    onChange={(e) => setTwoFactorCode(e.target.value)}
                    required
                  />
                </div>
              )}
              <div>
                <label>
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span> Remember me</span>
                </label>
              </div>
              <button className="button4" type="submit">
                {showTwoFactorInput ? "Verify" : "Login"}
              </button>
            </form>
          </main>
        </div>
      </div>
    </div>
  );
}

export default Login;
